import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {
  REVIEW_SUBMITTED,
  responseReceived,
  thanksForFeedback,
  hasSubmitted,
} from '../ducks/maryMagicSurvey';
import {
  BOOK,
  TOOLS,
  NAVIGATE,
  FEEL,
} from '../components/MaryMagicSurvey/components/SecondaryStarSelectors';

import { PRIMARY_RATING } from '../components/MaryMagicSurvey/components/PrimaryRatingSelector';
import { FREE_RESPONSE_FIELD } from '../components/MaryMagicSurvey/components/FreeResponseForm';
import { apiPostJson } from '../core/dapi';
import { MARY_MAGIC_SURVEY_MODAL } from '../constants/modalIds';
import { hideModal } from '../actions/runtime';
import {
  WHY_SOLV,
  WHY_SOLV_OTHER,
} from '../components/MaryMagicSurvey/components/WhySolvCheckboxes';
import { getMaryMagicSurveysUrl } from '../core/dapi/maryMagicSurveys';
import { analyticsTrackEvent } from '../core/analytics';
import { MARY_MAGIC_SURVEY_EVENT } from '../components/MaryMagicSurvey/constants';
import { convertSnakeToCamelCase } from '../core/util/object';
import { ACTION_SUBMIT } from '../core/analytics/events';

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'formData' implicitly has an 'any'... Remove this comment to see the full error message
function* submitForm({ payload: { value: formData } }) {
  try {
    const postData = {
      overall_rating: formData[PRIMARY_RATING],
      why_solv: formData[WHY_SOLV],
      why_solv_other: formData[WHY_SOLV_OTHER],
      free_response: formData[FREE_RESPONSE_FIELD],
      book_rating: formData[BOOK],
      tools_rating: formData[TOOLS],
      navigate_rating: formData[NAVIGATE],
      feel_rating: formData[FEEL],
      account_id: formData.accountId,
      source: formData.source,
      market: formData.market,
    };

    const response = yield call(apiPostJson, getMaryMagicSurveysUrl(), postData);

    if (response.errors) {
      yield put(responseReceived('error'));
      return;
    }

    analyticsTrackEvent(MARY_MAGIC_SURVEY_EVENT, {
      action: ACTION_SUBMIT,
      ...convertSnakeToCamelCase(postData),
    });

    yield put(responseReceived('success'));

    yield call(delay, 1000);
    yield put(thanksForFeedback());
    yield call(delay, 4000);
    yield put(hideModal(MARY_MAGIC_SURVEY_MODAL));
    yield put(hasSubmitted(true));
  } catch (e) {
    yield put(responseReceived('error'));
  }
}

function* rootSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  yield takeLatest(REVIEW_SUBMITTED, submitForm);
}

export { rootSaga as default };
